import * as React from 'react';

var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 5.333a4 4 0 014 4V14H12V9.334a1.334 1.334 0 00-2.667 0V14H6.667V9.334a4 4 0 014-4v0zM4 6H1.333v8H4V6zM2.667 4a1.333 1.333 0 100-2.666 1.333 1.333 0 000 2.666z",
    stroke: "currentColor"
  })));
}

export { SvgLinkedin as default };
//# sourceMappingURL=linkedin.svg.js.map
